import * as types from './action_types';
import * as SubscriberActions from '../subscriptions/actions';
import * as FeedActions from '../feed/actions';
import AccountMapper from '../utils/account_mapper';
import AccountConfirmationService from '../../services/account_confirmation';
import MagicLinkService from '../../services/magic_link';
import UserLoginService from '../../services/user_login';
import TokenStorage from '../../services/utils/token_storage';
import AccountDeleterService from '../../services/account_deleter';
import TackPauserService from '../../services/tack_pauser';
import AccountUpdater from '../../services/account_updater';
import AccountCreator from '../../services/account_creator';
import AccountRetriever from '../../services/account_retriever';
import IntraAppMessagingService from '../../services/intra_app_messaging_service';
import TimezoneService from '../../services/timezone_service';

export const reset = () => {
  return (dispatch) => {
    dispatch({ type: types.USER_RESET });
  }
}

export const confirmUser = (confirmationToken) => {
  return async(dispatch) => {
    try {
      const userData = await AccountConfirmationService.confirmUser(confirmationToken);
      await dispatch(loginWithAuthToken(userData.auth_token));
      dispatch({ type: types.USER_CONFIRMED });
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
}

export const startLoginProcess = (email) => {
  return async(dispatch) => {
    try {
      await MagicLinkService.startAuthenticationProcess(email);
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
}

export const createAccount = (email) => {
  return async(dispatch) => {
    try {
      await AccountCreator.create(email);
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
}

export const fetchAccount = () => {
  return async(dispatch) => {
    try {
      const userData = await AccountRetriever.fetchForLoggedInUser();
      const user = AccountMapper.map(userData);
      dispatch({ type: types.USER_ACCOUNT_RETRIEVED, user });
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
}

export const loginWithMagicLink = (token) => {
  return async(dispatch) => {
    try {
      dispatch(logout());
      const userData = await MagicLinkService.authenticate(token);
      await dispatch(loginWithAuthToken(userData.auth_token));
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
}

export const loginIfAuthToken = () => {
  return async(dispatch) => {
    const authToken = TokenStorage.getAuthToken();
    if (authToken) {
      dispatch(loginWithAuthToken(authToken));
    }
  };
};

export const loginWithAuthToken = (authToken) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.USER_LOADING });
      const userData = await UserLoginService.login(authToken);
      const user = AccountMapper.map(userData);
      dispatch(SubscriberActions.fetch(user.email));
      dispatch(FeedActions.followsFeed());
      IntraAppMessagingService.shareAuthTokenWithMobileApp(authToken);
      TimezoneService.setTimezone();
      dispatch({ type: types.USER_LOGGED_IN, user });
    } catch(error) {
      dispatch(logout());
      dispatch({ type: types.USER_ERROR, error });
    }
  }
}

export const logout = () => {
  return (dispatch) => {
    UserLoginService.logout();
    IntraAppMessagingService.notifyLoggedOut();
    dispatch({ type: types.USER_LOGGED_OUT });
  }
}

export const update = (name, headline, makePublic) => {
  return async(dispatch) => {
    dispatch({ type: types.USER_LOADING });
    try {
      const userData = await AccountUpdater.update(name, headline, makePublic);
      const user = {
        public: userData.public,
        headline: userData.headline,
        name: userData.name
      }
      dispatch({ type: types.USER_UPDATED, user });
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
}

export const deleteAccount = () => {
  return async(dispatch) => {
    dispatch({ type: types.USER_LOADING });
    try {
      await AccountDeleterService.delete();
      dispatch({ type: types.USER_DELETED });
      dispatch(logout());
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
};

export const pauseAll = () => {
  return async(dispatch) => {
    dispatch({ type: types.USER_LOADING });
    try {
      await TackPauserService.pauseAll();
      dispatch({ type: types.ALL_TACKS_PAUSED });
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
};

export const resumeAll = () => {
  return async(dispatch) => {
    dispatch({ type: types.USER_LOADING });
    try {
      await TackPauserService.resumeAll();
      dispatch({ type: types.ALL_TACKS_RESUMED });
    } catch(error) {
      dispatch({ type: types.USER_ERROR, error });
    }
  }
};



// WEBPACK FOOTER //
// ./src/stores/user/actions.js